import { ITagResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { IAnalyticsExtConnectionSettings } from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';
import { TagRequest } from '../../../TagRequest';

export type IUpdateAnalyticsExtConnectionSettingsResult = ITagResult & IAnalyticsExtConnectionSettings;

export class UpdateAnalyticsExtConnectionSettingsRequest extends TagRequest<IAnalyticsExtConnectionSettings, IUpdateAnalyticsExtConnectionSettingsResult> {
  constructor(params: IAnalyticsExtConnectionSettings) {
    super('analyticsextensions', 'updateAnalyticsExtensionsConnection', params);
  }
}
